
export function getCurrentPage (state) {
  return state.currentPage;
}
export function getUserCurrentLocation (state) {
  return state.userCurrentLocation;
}

export function getLoggedUser (state) {
  return state.loggedUser;
}

export function getLoggedToken (state) {
  return state.loggedToken;
}


